import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ContentfulModalNews } from 'src/skins/common/news/ContentfulModalNews';
import { MarsModal } from 'src/skins/mars/components/common';

const Wrapper = styled.div`
  width: 100%;

  .img-placeholder {
    margin-bottom: 10px;
    width: calc(100% + 3rem);
    margin-left: 50%;
    transform: translateX(-50%);
    object-fit: cover;
    height: 15rem;
    object-position: top;
  }

  .title {
    font-size: 18px;
    line-height: 24px;
    color: ${props => props.theme.color.white};
  }

  .content > p {
    color: ${props => props.theme.color.mars.gray};
    font-size: 1.1em;
    margin: 10px 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 18px;
  }
  .read-more {
    display: flex;
    gap: 10px;
    align-items: center;
    color: ${props => props.theme.color.gray};
    &:hover {
      color: ${props => props.theme.color.primary};
    }
    img {
      filter: brightness(0) saturate(100%) invert(83%) sepia(52%) saturate(3167%) hue-rotate(306deg) brightness(93%)
        contrast(98%);
    }
  }
`;

const LatestNewsModal = ({ isOpen, closeModal, latestNews, isLoadingNews, newsContent }) => {
  return (
    <MarsModal isOpen={isOpen} closeModal={closeModal} showCloseButton>
      <Wrapper>
        <ContentfulModalNews latestNews={latestNews} isLoadingNews={isLoadingNews} newsContent={newsContent} />
      </Wrapper>
    </MarsModal>
  );
};

LatestNewsModal.defaultProps = {
  isOpen: false,
  closeModal: null,
};

/**
 * LatestNewsModal PropType Definition
 * @typedef {Object} LatestNewsModalProps
 * @property {boolean} isOpen
 * @property {Function} closeModal
 * @property {any} newsContent
 * @property {Object} latestNews
 * @property {boolean} isLoadingNews
 */
LatestNewsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  latestNews: PropTypes.object,
  isLoadingNews: PropTypes.bool,
  newsContent: PropTypes.any,
};

export { LatestNewsModal };
